import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://gyjedcjcilmhzrhljsvg.supabase.co';
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd5amVkY2pjaWxtaHpyaGxqc3ZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ4NTU0NTQsImV4cCI6MjA4MDQzMTQ1NH0.b0RssjkA-39Ph3cskrISnQJhpmxboZI5DdPR_9fNLlE';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

// Hardcoded user ID for direct DB access
export const HARDCODED_USER_ID = '00000000-0000-0000-0000-000000000001';

// Direct DB functions using hardcoded credentials
export const dbClient = {
  async getExpenses(month: string) {
    const { data, error } = await supabase
      .from('expenses')
      .select('*')
      .eq('user_id', HARDCODED_USER_ID)
      .eq('month', month);
    if (error) throw error;
    return data || [];
  },

  async saveExpenses(month: string, expenses: any[]) {
    // Delete old expenses for this month
    await supabase
      .from('expenses')
      .delete()
      .eq('user_id', HARDCODED_USER_ID)
      .eq('month', month);

    // Insert new expenses
    if (expenses.length === 0) return;
    
    const { error } = await supabase
      .from('expenses')
      .insert(
        expenses.map(exp => ({
          user_id: HARDCODED_USER_ID,
          month,
          category: exp.category,
          item: exp.item,
          amount: exp.amount,
          type: exp.type
        }))
      );
    if (error) throw error;
  },

  async getIncomes(month: string) {
    const { data, error } = await supabase
      .from('monthly_tracker')
      .select('*')
      .eq('user_id', HARDCODED_USER_ID)
      .eq('month', month);
    if (error) throw error;
    return data?.[0] || null;
  },

  async saveIncomes(month: string, incomes: any[]) {
    // Upsert incomes into monthly_tracker
    const { error } = await supabase
      .from('monthly_tracker')
      .upsert({
        user_id: HARDCODED_USER_ID,
        month,
        incomes: incomes,
        updated_at: new Date().toISOString()
      }, { onConflict: 'user_id,month' });
      
    if (error) throw error;
  },

  async updateMonthlyData(month: string, data: { emergencyFund?: number; debtPayments?: number; savingsGoal?: number }) {
    // Check if exists first
    const { data: existing } = await supabase
      .from('monthly_tracker')
      .select('id')
      .eq('user_id', HARDCODED_USER_ID)
      .eq('month', month)
      .single();

    if (existing) {
      const { error } = await supabase
        .from('monthly_tracker')
        .update({
          emergency_fund: data.emergencyFund,
          debt_payments: data.debtPayments,
          savings_goal: data.savingsGoal,
          updated_at: new Date().toISOString()
        })
        .eq('user_id', HARDCODED_USER_ID)
        .eq('month', month);
      if (error) throw error;
    } else {
      const { error } = await supabase
        .from('monthly_tracker')
        .insert({
          user_id: HARDCODED_USER_ID,
          month,
          emergency_fund: data.emergencyFund || 0,
          debt_payments: data.debtPayments || 0,
          savings_goal: data.savingsGoal || 0,
          incomes: []
        });
      if (error) throw error;
    }
  },

  async getAllExpensesByMonth() {
    const { data, error } = await supabase
      .from('expenses')
      .select('*')
      .eq('user_id', HARDCODED_USER_ID);
    if (error) throw error;
    return data || [];
  }
};
